export const initDelivery = function() {
  //   Show delivery address START
  const basketRadioParent = document.querySelector('[data-radio-delivery="parent"]');

  if (basketRadioParent) {
    const containerItem = basketRadioParent.querySelectorAll('[data-radio-delivery-item]');
    // const containerPickup = basketRadioParent.querySelector('[data-radio-delivery="pickup"]');
    const radioInputs = basketRadioParent.querySelectorAll('input[type="radio"]');

    if (radioInputs.length > 0) {
      radioInputs.forEach((el) => {
        el.addEventListener('change', (e) => {
          const elId = el.getAttribute('id');
          if (containerItem.length > 0) {
            containerItem.forEach((item) => {
              if (item.dataset.radioDeliveryItem === elId) {
                if (!item.classList.contains('is-active')) {
                  item.classList.add('is-active');
                }
              } else {
                if (item.classList.contains('is-active')) {
                  item.classList.remove('is-active');
                }
              }
            });
          }
        });
      });
    }
  }
  //   Show delivery address END
};
